import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { checkUserPermission } from "../../utils";

interface PermissionGuardProps {
    permission: string;
    children: ReactNode;
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({
    permission,
    children,
}) => {
    const loggedUser = useSelector((state: RootState) => state.authUser);

    const hasPermission = checkUserPermission(loggedUser, permission);

    if (!hasPermission) {
        return null;
    }

    return <>{children}</>;
};

export default PermissionGuard;
